import SalesFlyerApp from "./components/SalesFlyerApp.vue";
import Vue from "vue";
import VueRouter from "vue-router";
import { provideIsMobileAppWebView } from "./composables/mobile-app-web-view";
import { SalesFlyerResource } from "./types";

const el = document.querySelector<HTMLElement>('#sales-flyer-app');
const activeSalesFlyers: SalesFlyerResource[] = JSON.parse(el.dataset.activeSalesFlyers);
const isMobileAppWebView = el.dataset.isMobileAppWebView === 'true';

const base = isMobileAppWebView ? '/sales-flyer-mobile/' : '/sales-flyer/';

const router = new VueRouter({
	base,
	mode: 'history',
	routes: [
		{
			path: '*',
			component: SalesFlyerApp,
			props: route => {
				const selectedPromoNumber = typeof route.query.promo === 'string'
					? +route.query.promo
					: activeSalesFlyers[0]?.promoNumber;

				const salesFlyer = !isNaN(selectedPromoNumber)
					? activeSalesFlyers.find(sf => sf.promoNumber === selectedPromoNumber) ?? null
					: null;

				return {
					activeSalesFlyers,
					salesFlyer,
				};
			}
		}
	],
});

Vue.use(VueRouter);

new Vue({
	el,
	router,
	render: h => h('router-view'),
	setup() {
		provideIsMobileAppWebView(isMobileAppWebView);
	}
});